import { useProcess } from '@fasstech/oip-starter-utils/app';
import { useEffect, useRef } from 'react';
import { useSelfcareRelay } from '@@viewCommonHooks/useSelfcareRelay.js';

export const usePreviousInBackButton = () => {
  const { processHandlers, context } = useProcess();
  const { previousIsBlocked } = useSelfcareRelay();

  const handlerRef = useRef();
  handlerRef.current = () => {
    if (previousIsBlocked) return;

    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);

    const handler = () => {
      history.pushState(null, '', window.location.href);
      handlerRef.current();
    };

    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);
};
